import type { IExtractParams } from "@/routes";
import { apiPathFunc } from "@api/util/apiPathFunc";

const pathBase = `/course-subject-categories/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const subjectCategories = {
  getAll: apiPathFunc(pathBase),
} as const;
